/*
no-cache-ajax.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
require(['jquery'], function () {

    var addCacheControl = function (xhr, settings) {
        var isGETRequest = !settings.type || settings.type.toUpperCase() === 'GET';
        console.log('checking if no-cache required');
        if (isGETRequest && settings.cache !== true) {
            xhr.setRequestHeader('Cache-Control', 'no-cache, no-store, must-revalidate');
            xhr.setRequestHeader('Pragma', 'no-cache');
            xhr.setRequestHeader('Expires', '0');
            console.log('Setting no-cache headers');
        }
    };

    var originalBeforeSend = $.ajaxSetup().beforeSend;

    $.ajaxSetup({
        beforeSend: function (xhr, settings) {
            originalBeforeSend && originalBeforeSend(xhr, settings);
            addCacheControl(xhr, settings);
        }
    });
});

define("no-cache-ajax", function(){});

